import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from '../../../../../../../common/table'
import { SORT_DIRECTION } from '../../../../../../../utils/common'
import { schemaTable, TYPE_SORT_BY } from './schema/schemaTable'
import {
  changeFilter,
  changeIds,
  getDataReduxTable,
  selectDataRawTable,
  selectFilter,
  selectIdsRawTable,
  selectIdsTable,
  selectLoadingTable,
} from './store/slice'

const CorporateLinkageScoreTable = ({ isDynamicReport }) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIdsTable)
  const isLoading = useSelector(selectLoadingTable)
  const filter = useSelector(selectFilter)
  const dataTable = useSelector(selectDataRawTable)
  const idsRaw = useSelector(selectIdsRawTable)

  const handleChangeSort = (value) => {
    dispatch(changeFilter(value))
  }

  useEffect(() => {
    if (!filter?.sortDirection) {
      dispatch(changeIds(idsRaw))
      return
    }
    const sortBy = filter.sortBy
    const isStringSort = [
      TYPE_SORT_BY.ORG_NAME,
      TYPE_SORT_BY.RELATIONSHIP,
      TYPE_SORT_BY.COMPANY_SIZE,
    ].includes(sortBy)

    const sortedData = [...dataTable].sort((a, b) => {
      let comparison = 0
      if (isStringSort) {
        comparison = a[sortBy]
          ?.toString()
          .localeCompare(b[sortBy]?.toString(), 'vi')
      } else {
        comparison = (a[sortBy] || 0) - (b[sortBy] || 0)
      }
      comparison =
        filter.sortDirection === SORT_DIRECTION.DESC ? -comparison : comparison
      if (sortBy === TYPE_SORT_BY.RELATIONSHIP && comparison === 0) {
        comparison = a[TYPE_SORT_BY.ORG_NAME]
          ?.toString()
          .localeCompare(b[TYPE_SORT_BY.ORG_NAME]?.toString(), 'vi')
      }

      return comparison
    })

    const newIds = sortedData.map((item) => item.organizationId)
    dispatch(changeIds(newIds))
  }, [filter, dataTable, idsRaw])

  return (
    <Table
      ids={ids}
      getDataFromRedux={getDataReduxTable}
      isLoading={isLoading}
      noDataText="score.premium.NODATA_TABLE"
      schema={schemaTable(isDynamicReport)}
      autoHeightMax={332}
      changeSort={handleChangeSort}
      sort={filter}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      isNoDataWithHead={!isDynamicReport}
    />
  )
}

export default CorporateLinkageScoreTable
